import { DeviceDebugStreamPanel } from "./DeviceDebugStreamPanel.jsx";

export function DeviceDebugPanel({ device }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", background: "inherit" }}>
      <DeviceDebugStreamPanel device={device} />
    </div>
  );
}
